<template>
    <div class="online-wrap">
        <div class="title"><img src="./images/icon01.png" /> 设备在线情况</div>
        <div class="online_con" id="online"></div>
    </div>
</template>
<script>
import echarts from 'echarts/lib/echarts';

export default {
    name:"online",
    data(){
        return {
            online:{v1:10,v2:11,v3:12,v4:15,v5:17,v6:18}
        }
    },
    mounted(){
        this.init();
    },
    methods:{
        // 初始化
        init(){
            var dom = document.getElementById("online");
            var myChart = echarts.init(dom);
            let option = null;
            option = {
                legend: {
                    x : 'center',
                    y : 'bottom',
                    itemWidth: 8,
                    itemHeight: 8,
                    textStyle:{//图例文字的样式
                        color:'#fff',
                        fontSize:12
                    },
                    data:['上限','上上限','下限','下下限','正跳变','负跳变']
                },
                calculable : true,
                series : [
                    {
                        name:'面积模式',
                        type:'pie',
                        radius : [30, 100],
                        center : ['50%', '45%'],
                        roseType : 'area',
                        data:[
                            {value:this.online.v1, name:'上限',itemStyle:{normal:{color:'#ff7800'}}},
                            {value:this.online.v2, name:'上上限',itemStyle:{normal:{color:'#23eb6a'}}},
                            {value:this.online.v3, name:'下限',itemStyle:{normal:{color:'#7627cb'}}},
                            {value:this.online.v4, name:'下下限',itemStyle:{normal:{color:'#fffc00'}}},
                            {value:this.online.v5, name:'正跳变',itemStyle:{normal:{color:'#46afdb'}}},
                            {value:this.online.v6, name:'负跳变',itemStyle:{normal:{color:'#ff0000'}}}
                        ]
                    }
                ]
            }
            if (option && typeof option === "object") {
                myChart.setOption(option, true);
            }
        }
    }
}
</script>

<style lang="scss">
.online-wrap{
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    
    .online_con{
        flex:1;
        padding: 10px;
    }

}
</style>